/* tslint:disable */
/* eslint-disable */
export enum NotificationChannelType {
    Email = 1,
    Sms = 2,
    PushNotification = 3
}